import { formatterCurrency } from './config';

const formatCurrency = (currency, config) => {
  const {
    token
  } = currency;
  return formatterCurrency[token](currency, config);
};

export default formatCurrency;